import { Component, OnInit } from '@angular/core';
import {ApiService} from '../../../../projects/accounting/src/public_api';

@Component({
  selector: 'app-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.scss']
})
export class GeneralComponent implements OnInit {
  loading = false;
  data = null;
  constructor(
      private api: ApiService
  ) { }

  ngOnInit() {
  }
  load(e){
    this.loading = true;
    this.data = null;
    this.api.general(e).subscribe(rs => {
      this.loading = false;
      if (rs.succeed){
        let result = [];
        for(let k in rs.data){
          let dt = {
            type: k,
            expensesTotal: 0,
            incomesTotal: 0,
            assetsTotal: 0,
            details: null,
            name: this.translateName(k)
          };
          let dtLU = {};

          rs.data[k].Expenses.forEach(i => {
              if (typeof dtLU[i.Key] === 'undefined'){
                dtLU[i.Key] = {
                  key: i.Key,
                  expenses: i.Value,
                  incomes: 0,
                  assets: 0,
                }
              }else{
                dtLU[i.Key] += i.Value;
              }
              dt.expensesTotal += i.Value;
          });

          rs.data[k].Incomes.forEach(i => {
              if (typeof dtLU[i.Key] === 'undefined'){
                dtLU[i.Key] = {
                  key: i.Key,
                  expenses: 0,
                  incomes: i.Value,
                  assets: 0,
                }
              }else{
                dtLU[i.Key].incomes += i.Value;
              }
            dt.incomesTotal += Math.abs(i.Value)
          });
          rs.data[k].Assets.forEach(i => {
            if (typeof dtLU[i.Key] === 'undefined'){
              dtLU[i.Key] = {
                key: i.Key,
                expenses: 0,
                incomes: 0,
                assets: i.Value
              }
            }else{
              dtLU[i.Key].assets += i.Value;
            }
            dt.assetsTotal += i.Value
          });
          dt.details = Object.keys(dtLU).map(k => dtLU[k]);
          result.push(dt);
        }
        this.data = result;
      }
    });
  }
  translateName(type) {
    switch (type) {
      case 'Franchise':
        return 'Nhượng quyền';
      case 'IceCreamFactory':
        return 'Kho kem';
      case 'RoastingFactory':
        return 'Kho cafe';
      case 'Warehouse':
        return 'Kho tổng';
      default:
        return type;
    }
  }
}
